/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmAuthV1ApiKeyEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_AUTH_V1_API_KEY_EVENT_ENTITY_NAME = 'ixm.auth.v1.ApiKeyEvent';
export const ixmAuthV1ApiKeyEventEntity = new schema.Entity<IxmAuthV1ApiKeyEvent>(IXM_AUTH_V1_API_KEY_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmAuthV1ApiKeyEvent) => `${entity.metadata?.eventId}` });

